import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo, useState } from "react";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { IFondo } from "../../../../../../../interfaces/lotto/attributes/models";
import { isFilterAndValueSelected } from "../../../../../../../lib/filters";
import { useAppSelector } from "../../../../../../../store/hooks";
import { IFilterProps } from "../../interfaces";

function FondiFilter({ filters, setFilters }: IFilterProps) {
  const [open, setOpen] = useState<boolean>(false);

  const fondoList = useAppSelector((state) => state.lotto_fondo.list);
  const fondoItems = useAppSelector((state) => state.lotto_fondo.items);

  const list: IFondo[] = useMemo(
    () =>
      !!fondoList && !!fondoItems ? fondoList.map((id) => fondoItems[id]) : [],
    [fondoList, fondoItems]
  );

  const toggle = () => {
    setOpen(!open);
  };

  const toggleSelected = (item: IFondo) => {
    if (isFilterAndValueSelected(filters, EOptionType.fondo, item.id)) {
      setFilters(
        filters.filter(
          (opt) =>
            !(opt.type === EOptionType.fondo && opt.numericValue === item.id)
        )
      );
    } else {
      setFilters([
        ...filters,
        {
          type: EOptionType.fondo,
          numericValue: item.id,
          stringValue: item.nome,
        },
      ]);
    }
  };

  return (
    <>
      <ListItemButton onClick={toggle}>
        <ListItemIcon>
          <Icon className="fa-light fa-palette" sx={{ overflow: "visible" }} />
        </ListItemIcon>
        <ListItemText primary="Fondi" />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense={true}>
          {list.map((item) => (
            <ListItemButton
              key={item.id}
              sx={{ display: "flex", pl: 5, pr: 1 }}
              onClick={() => toggleSelected(item)}
              selected={isFilterAndValueSelected(
                filters,
                EOptionType.fondo,
                item.id
              )}
            >
              <ListItemText sx={{ flex: 1 }} primary={item.nome} />
              <ListItemIcon sx={{ minWidth: 0 }}>
                {isFilterAndValueSelected(
                  filters,
                  EOptionType.fondo,
                  item.id
                ) && (
                  <Icon
                    className="fa-light fa-check"
                    sx={{ overflow: "visible" }}
                  />
                )}
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default FondiFilter;
